import { render, staticRenderFns } from "./NpRecognitionCreate.vue?vue&type=template&id=56becf6a"
import script from "./NpRecognitionCreate.vue?vue&type=script&lang=js"
export * from "./NpRecognitionCreate.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionCreate.vue?vue&type=style&index=0&id=56becf6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports